import {
  IAssured,
  IEAssured,
  IError,
  IshowErrorAssuredDefault,
  IshowErrorValuesDefault,
  IValues,
} from '../../../types/interface/Assurance/AssuranceVoyage/modification';

export const showErrorValuesDefault: IshowErrorValuesDefault = {
  destination: false,
  dateDebut: false,
  dateFin: false,
  assure: [],
};
export const showErrorAssuredSubmit = {
  nom: true,
  prenom: true,
  email: true,
  phoneNumber: true,
  passeportNumber: true,
  passeportFile: true,
  passeportFileBase64: true,
};
export const showErrorValuesSubmit = {
  destination: true,
  dateDebut: true,
  dateFin: true,
  assure: [],
};
export const defaultErrorAssured: IEAssured = {
  id: '',
  nom: '',
  prenom: '',
  email: '',
  phoneNumber: '',
  passeportNumber: '',
  passeportFile: '',
  passeportFileBase64: '',
};
export const defaultErrorValues: IError = {
  destination: '',
  dateDebut: '',
  dateFin: '',
  assure: [],
};
export const defaultAssured: IAssured = {
  id: '',
  nom: '',
  prenom: '',
  email: '',
  phoneNumber: '',
  countryCode: 'MG',
  passeportNumber: '',
  passeportFile: '',
  newImage: false,
};
export const defaultValues: IValues = {
  destination: '',
  dateDebut: '',
  dateFin: '',
  assure: [],
};

export const showErrorAssuredDefault: IshowErrorAssuredDefault = {
  id: '',
  nom: false,
  prenom: false,
  email: false,
  phoneNumber: false,
  passeportNumber: false,
  passeportFile: false,
};
